import { BzDateFns, IsoDateString } from '../../../common'
import { AccountGuid } from '../../Accounts/Account'
import { CompanyGuid } from '../../Company/Company'
import { Guid } from '../../common-schemas'
import { ContactGuid } from '../../contacts/Contact'
import { JobGuid } from '../../Job'
import { PrequalRecord, PrequalRecordWithContactName, PrequalStatus } from './Prequal'

export type FetchPrequalRecord = {
  wisetackPrequalRecordGuid: Guid
  companyGuid: CompanyGuid
  accountGuid: AccountGuid
  contactGuid: ContactGuid
  jobGuid?: JobGuid
  wisetackPrequalGuid: Guid
  wisetackMerchantGuid: Guid
  prequalifiedAmountUsc?: number
  maxQualifiedAmountUsc?: number
  aprRange?: string
  status: PrequalStatus
  expirationDate?: IsoDateString
  prequalifiedAt?: IsoDateString
  declinedAt?: IsoDateString
  expiredAt?: IsoDateString
  createdAt?: IsoDateString
  updatedAt?: IsoDateString
  prequalLink: string
}

export type FetchPrequalRecordStatus = PrequalStatus

export type FetchPrequalRecordWithContactName = FetchPrequalRecord & {
  contact?: {
    fullName?: string
  }
}

export const convertFetchPrequalRecordToPrequalRecord = (input: FetchPrequalRecord): PrequalRecord => {
  const nowIso = BzDateFns.nowISOString() as IsoDateString
  const createdAt =
    input.createdAt ??
    input.updatedAt ??
    input.prequalifiedAt ??
    input.expirationDate ??
    input.declinedAt ??
    input.expiredAt ??
    nowIso
  const updatedAt = input.updatedAt ?? createdAt

  return {
    prequalRecordGuid: input.wisetackPrequalRecordGuid,
    companyGuid: input.companyGuid,
    accountGuid: input.accountGuid,
    contactGuid: input.contactGuid,
    jobGuid: input.jobGuid,
    merchantGuid: input.wisetackMerchantGuid,
    prequalifiedAmountUsc: input.prequalifiedAmountUsc,
    maxQualifiedAmountUsc: input.maxQualifiedAmountUsc,
    externalPrequalGuid: input.wisetackPrequalGuid,
    aprRange: input.aprRange,
    status: input.status,
    expirationDate: input.expirationDate,
    prequalifiedAt: input.prequalifiedAt,
    declinedAt: input.declinedAt,
    expiredAt: input.expiredAt,
    createdAt,
    updatedAt,
    prequalLink: input.prequalLink,
  }
}

export const convertPrequalRecordToFetchPrequalRecord = (input: PrequalRecord): FetchPrequalRecord => ({
  wisetackPrequalRecordGuid: input.prequalRecordGuid,
  companyGuid: input.companyGuid,
  accountGuid: input.accountGuid,
  contactGuid: input.contactGuid,
  jobGuid: input.jobGuid,
  wisetackMerchantGuid: input.merchantGuid,
  prequalifiedAmountUsc: input.prequalifiedAmountUsc,
  maxQualifiedAmountUsc: input.maxQualifiedAmountUsc,
  wisetackPrequalGuid: input.externalPrequalGuid,
  aprRange: input.aprRange,
  status: input.status,
  expirationDate: input.expirationDate,
  prequalifiedAt: input.prequalifiedAt,
  declinedAt: input.declinedAt,
  expiredAt: input.expiredAt,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
  prequalLink: input.prequalLink,
})

export const convertFetchedToPrequalRecordWithContactName = (
  input: FetchPrequalRecordWithContactName,
): PrequalRecordWithContactName => {
  const { contact, ...rest } = input
  const prequalRecord = convertFetchPrequalRecordToPrequalRecord(rest)
  return {
    ...prequalRecord,
    contactFullName: contact?.fullName ?? '',
  }
}
